module.exports = __webpack_public_path__ + "static/media/ELEVEN.36a246dd.png";